/**
 * Animated gold gradient shimmer on section headings.
 * Triggers once on scroll-into-view via IntersectionObserver.
 * Respects prefers-reduced-motion.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  var style = document.createElement('style');
  style.textContent =
    '@keyframes lbjGoldShimmer{0%{background-position:200% center}100%{background-position:-200% center}}' +
    '.lbj-gold-text{background:linear-gradient(90deg,currentColor 30%,#d4af37 45%,#f5e6a3 50%,#d4af37 55%,currentColor 70%);' +
    'background-size:200% auto;-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;' +
    'animation:lbjGoldShimmer 2.5s ease-in-out 1 forwards;background-position:200% center;}' +
    '.lbj-gold-text.lbj-gold-done{background:none;-webkit-text-fill-color:unset;-webkit-background-clip:unset;background-clip:unset;animation:none;}';
  document.head.appendChild(style);

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      entry.target.classList.add('lbj-gold-text');
      entry.target.addEventListener('animationend', function () {
        entry.target.classList.remove('lbj-gold-text');
        entry.target.classList.add('lbj-gold-done');
      }, { once: true });
    });
  }, { threshold: 0.4 });

  function init() {
    var headings = document.querySelectorAll(
      '.content-for-layout h1, .content-for-layout h2'
    );
    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      if (h.closest('.product-card, .collection-card, .cart-drawer, .pdl-hero')) continue;
      if (h.textContent.trim().length < 3) continue;
      if (!h.hasAttribute('data-gold-init')) {
        h.setAttribute('data-gold-init', '');
        observer.observe(h);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
